<template>
  <div class="f f-gap-48 f-as">
    <div class="fc-g0 fc-b50p">
      <div class="m-b12">
        <div class="t t-lg black m-bx1">About</div>
        <div class="t dark-gray">
          Shoutouts helps your team recognize great work and celebrate wins with
          personalized shoutouts that spread positivity and fit your team's
          culture, all within Slack.
        </div>
      </div>

      <div class="bg-light-purple p-x2 br-4">
        <div class="t bold black">Shoutouts</div>
        <div class="t ital dark-gray">Award and redeem points in Slack</div>
        <donut-storylane-preview
          id="0jf07gh1s3xn"
          class="br-8 m-tx1 mask"
          title="Shoutouts — Get started"
        />
      </div>
    </div>

    <div class="fc-g0 fc-b50p">
      <shoutouts-programs-setup-form v-bind="props" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  reauthData: { type: Object, default: null },
  program: { type: Object, required: true },
  noAccessReason: { type: String, default: null },
  shoutoutsAdmins: { type: Array, default: null },
  boostToggleDescription: { type: String, default: null },
});
</script>
